<template>
  <div class="indexBox">
    <div class="bigImg">
      <!-- <img class="topimg" src="../../static/wap/index/top.png" alt="" />
      <div class="title">智投全球</div>
      <div class="title">剑指非凡</div>
      <div class="titles">专业黄金平台 · 匠心成就梦想</div>
      <img class="download" @click="scrollToTarget" src="../../static/wap/index/download.png" alt="" /> -->
      <swiper class="swiper-container" v-if="swiperData" ref="mySwiper" :options="swiperOption"> 
        <div class="swiper-slide" v-for="(item,i) in swiperData" :key="i" @click="jumpClick(item.url)">
          <img :src="item.imgUrl" />
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div v-if="imgData" class="onlyBanner">
        <img @click="jumpClick(imgData.url)" :src="imgData.imgUrl !== '' ? imgData.imgUrl: ''" alt="">
      </div>
      <div class="topbox" v-if="!hideDate">
        <div class="flex boxs"  >
          <div class="left flex1">A</div>
          <div class="right">
            <span class="txts">伦敦金</span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ golds||0 }}</span>
              <span class="txt" style="color: #fa2314">{{priceRange.symbol}}  {{ priceRange.percentage }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class=" left flex1 " style="background: #A915AC;" >B</div>
          <div class="right">
            <span class="txts">伦敦银</span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ sliver||0}}</span>
              <span class="txt" style="color: #fa2314">{{priceRange1.symbol}}  {{ priceRange1.percentage }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class=" left flex1 " style="background: #15AC36">C</div>
          <div class="right">
            <span class="txts">美国原油 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ usd }}</span>
              <span class="txt" style="color: #fa2314">{{priceRange2.symbol}}  {{ priceRange2.percentage }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class="left flex1">D</div>
          <div class="right">
            <span class="txts">纳斯达克指数 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ nas}}</span>
              <span class="txt" style="color: #fa2314;width: 30px;">{{priceRange3.symbol}}  {{ priceRange3.percentage }}</span>
            </div>
          </div>
        </div>
        <div class="flex boxs"  >
          <div class="left flex1">E</div>
          <div class="right">
            <span class="txts">恒生指数 <span style="color: #fa2314;">(参考)</span></span>
            <div class="cont">
              <span class="txt" style="margin-right: 6px;">{{ hk50 }}</span>
              <span class="txt" style="color: #fa2314">{{priceRange4.symbol}}  {{ priceRange4.percentage }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1" v-if="!hideDate">
      <div class="indexTitle"><span>实时</span>数据分析</div>
      <div class="indexTitle1 part-tit">洞悉市场脉动，掌握交易先机</div>
      <div class="part1-top">
        <div  :class="selectIndex==1?'select icon1': 'icon1'" @click="btnChange" >
          <div class="flexs">
            <span class="indexTitle1">伦敦金</span>
            <span class="icon-txt1"
              >{{ golds||0 }}
              <span class="icon-txt" style="color: #0f0f11">USD</span></span
            >
            <span class="icon-txt">{{ priceRange.value }} {{ priceRange.symbol }} {{ priceRange.percentage }}</span>
          </div>
          <img src="../../static/wap/index/icon.png" alt="" />
        </div>
        <div :class="selectIndex==2?'select icon1': 'icon1'" @click="btnChange1">
          <div class="flexs">
            <span class="indexTitle1">伦敦银</span>
            <span class="icon-txt1"
              >{{sliver||0 }}
              <span class="icon-txt" style="color: #0f0f11">USD</span></span
            >
            <span class="icon-txt2"> {{ priceRange1.value }} {{ priceRange1.symbol }} {{ priceRange1.percentage }}</span>
          </div>
          <img src="../../static/wap/index/icon1.png" alt="" />
        </div>
      </div>
      <div id="echartsBox_one" class="echartsBoxItem"></div>
      <div class="part1-select">
          <div class="timelist">
            <div @click="selectTime(index)" v-for="(item,index) in timelist" :key="index" :class="selectIndex1==index?'selcts part1-felx1':'part1-felx1'">
              {{ item }}
            </div>
          </div>
          <div class="part1-felx">
            <div class="part1-box part1-felx1">
              <img @click="changeTypes1" src="../../static/index/part.png" :class="changeType==1?'changes mgs':'mgs'" alt="">
              <!-- k线图 -->
              <img @click="changeTypes" :class="changeType==2?'changes':''" src="../../static/index/line.png" alt="">
            </div>
           
          </div>
        </div>
    </div>
    <div class="part2" ref="targetElement">
      <div class="indexTitle"><span>下载</span>红狮APP</div>
      <div class="indexTitle1">
        多功能一站式平台，为您提供伦敦金、伦敦银等品种的开户、交易、出入金、产品报价、行情资讯、财经新闻、专家解盘、24h客服团队等服务，让您不惧时间和空间限制，随时随地使用手机进行交易。
      </div>
      <img class="phone" src="../../static/wap/index/phone.png" alt="" />
      <div class="part2-bott">
        <div>
          <img class="icons" src="../../static/wap/index/icon2.png" alt="" />
          <span>顶尖团队倾力打造</span>
        </div>
        <div>
          <img class="icons" src="../../static/wap/index/icon3.png" alt="" />
          <span>千日精心打磨细节</span>
        </div>
        <div>
          <img class="icons" src="../../static/wap/index/icon4.png" alt="" />
          <span>200+万用户使用</span>
        </div>
        <div>
          <img class="icons" src="../../static/wap/index/icon5.png" alt="" />
          <span>权威平台广泛认可</span>
        </div>
      </div>
      <div class="part2-down" v-if="showAndroid">
        <div class="code">
          <canvas class="canvasCode" ref="qrcodeCanvas"></canvas>
        </div>
        <div class="flexs">
          <img
            class="download"
            @click="androidDownload"
            src="../../static/wap/index/androld.png"
            alt=""
          />
          <img class="download" @click="iosDownload" src="../../static/wap/index/ios.png" alt="" />
          <span>扫码下载 {{appName}}APP</span>
        </div>
      </div>
    </div>
    <div class="part3">
      <div class="indexTitle">专注黄金交易</div>
      <div class="indexTitle"><span>一站式</span>管家服务</div>

      <div class="indexTitle1">金牌管家，财富之路领航者</div>
      <div class="flexs">
        <div class="part-flex" v-for="(item,index) in partData" :key="index">
          <div class="part3-left flexs">
            <span class="tops">{{item.name}}</span>
            <span class="line"></span>
            <span class="conts">
             
             {{item.cont}}
            </span>
          </div>
          <div class="part3-right">
            <img :src="item.img" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="part4">
      <div style="padding: 0 0.5rem;">
        <div class="indexTitle"><span>轻松黄金交易</span></div>
      <div class="indexTitle">品鉴愉悦人生</div>
      <div class="flexs">
        <div v-for="(item,index) in bottomData" :key="index">
            <div class="indexTitle1"><span> {{item.name}}</span>{{item.title}}</div>
      <div class="indexTitle1 tits">
      {{item.cont}}
      </div>
        </div>
      </div>
      </div>
      <img class="part4-img" src="../../static/wap/index/bottbg.png" alt="" />
    </div>
   
  </div>
</template>
<script>
import { base64ToFloat32 } from "../../utils/tools";
import { analyticalData } from "../../utils/tools";
import { getChannelInfo, getConfigurationValue } from "@/apis/common";


import { generateQRCode } from "../../utils/tools";
import * as echarts from 'echarts';
import eventBusMitter from '../../utils/eventbus'
import { queryBrandImgList } from '../apis/common';
import { getActiveDomain } from '../../utils/IMEI'

export default {
  name: "Index",
  metaInfo: {
    title: "红狮金业官网,15年贵金属交易平台,黄金交易平台",
    meta: [
      {
        name: "keywords",
        content:
          "红狮金业,红狮启富,黄金交易平台,贵金属交易,贵金属投资,贵金属平台,现货黄金开户,正规靠谱外汇交易,正规网上交易平台",
      },
      {
        name: "description",
        content:
          "红狮金业是专业值得信赖的国际投资交易平台,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。",
      },
    ],
  },
  data() {
    return {
      LondonImg: [
        //   require('../../static/index/jiaohu/up.png'),
        //   require('../../static/index/jiaohu/down.png'),
      ],
      // selectedImg: require('../../static/index/yuandian.png'),
      controlSwiper: true,
      controlDark: true,
      // swiper 参数
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        loop: true,
        preventClicks: true,
        //自动播放
        autoplay: {
          delay: 3000, //延迟播放下一张图片
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          // dynamicBullets: true,
        },
      },
      topData: [
        {
          name: "A",
          title: "伦敦金",
          title1: "45612.25 USD",
          title2: "+ 0.01%",
        },
        {
          name: "B",
          title: "伦敦银",
          title1: "45612.25 USD",
          title2: "+ 0.01%",
        },
        {
          name: "C",
          title: "美国原油",
          title1: "45612.25 USD",
          title2: "+ 0.01%",
        },
        {
          name: "D",
          title: "纳斯达克指数",
          title1: "45612.25 USD",
          title2: "+ 0.01%",
        },
        {
          name: "E",
          title: "恒生指数",
          title1: "45612.25 USD",
          title2: "+ 0.01%",
        },
      ],
      partData:[
        {
            name:'权威平台',
            cont:'集团获的香港黄金交易所监管属香港黄金交易所AA类行员且多次获得“最佳贵金属交易平台金企”称号',
            img:require('../../static/wap/index/card1.png')
        },
         {
            name:'资金安全',
            cont:'出入金顺畅，资金安全有保障，可在APP或用户中心即时查看资金变动的具体情况',
             img:require('../../static/wap/index/card2.png')
        },
         {
            name:'服务专业',
            cont:'7*24小时专业客服，随时解决您任何投资疑问',
             img:require('../../static/wap/index/card3.png')
        },
         {
            name:'丰富活动',
            cont:'享优越点差，省即是赚，同时还有丰富的新用户注册活动，享赠金好礼',
             img:require('../../static/wap/index/card4.png')
        },
         {
            name:'软件强大',
            cont:'全新智能化软件，独家开发交易利器，超强下单执行能力，是您交易的强大后盾',
             img:require('../../static/wap/index/card5.png')
        },
      ],
      bottomData:[
        {
            name:'稳值增值',
            title:'（时光流转 价值永存）',
            cont:'从古代起黄金便已开始被当作货币来交易，流传千年经久不衰，他的价值不论国界不分币种，是全世界公认保值性极高的贵金属。'
        },
        {
            name:'双向机制',
            title:'（进退自如 无惧牛熊））',
            cont:'黄金是可以双向交易的产品，既可以做多也可以做空，选对行情两边皆是机会。因此在国际金融环境毕竟动荡的今天，选择黄金能对冲很多风险。'
        },
        {
            name:'市场透明',
            title:'（信息对称 交易公正）',
            cont:'全球有8大黄金市场，尽管分布极为广泛，却是全球统一透明的价格，全球交易拥有通行的规则和价格，是可以所见即所得的放心产品。'
        },
        {
            name:'交易灵活',
            title:'（随时随地 皆可操作）',
            cont:'黄金拥有24小时交易时间，支持智能挂单，智能止盈止损，是可以实现随时随地，随心交易，即使离线，也能精准执行操作。'
        },
      ],
      // 控制serveBox
      controlDiv: 1,
      craigCao: 0,
      London: {
        gold: "--",
        silver: "--",
        goldRise: "0.0",
        silverRise: "0.0",
        goldPer: "0.00%",
        silverPer: "0.00%",
        controlPic: true,
        controlPicOther: true,
      },
      closerControl: true,
      goldCl: "",
      silverCl: "",
      ahref:
        "https://www.rlcltd001.com/#/subject/worldCup/wap?craig=" +
        window.location.origin,
      swiperData: "",
      imgData: "",
      timelist:['1天','1个月','3个月','1年'],//时间数组
      selectIndex:'1',
      selectIndex1:'0',//时间的选择
      changeType:'1',//图表类型
       sbldata:{
      
      },
      highLowData:{},
      screenWidth: document.body.clientWidth,//实时屏幕宽度
      hideDate:false,
      appName:'红狮乐富',
        showAndroid: true,
    };
  },
  created() { 
      const Rhref = window.location.host;

    if (Rhref.indexOf('hspluspro') > -1) {
      this.appName = '乐富智享'
    }
    if (Rhref.indexOf('rlctop') > -1) {
      this.showAndroid = false
    }
    // 传参控制显示顶部和底部
    this.$emit("controlShow", false);
    setTimeout(() => {
      eventBusMitter.emit('eventBus1', {key:0})
      eventBusMitter.emit('eventtab', { key: true })

     this.initCharts()
    }, 500); // 秒后关闭弹窗
    this.initSwiper()
     const channel = sessionStorage.getItem('channel');

      this.getAndroidUrl(channel);
      this.getIosUrl()
  },
  mounted() {
     this.initCharts()

    const { origin } = window.location;
      const channel = this.appName == '乐富智享' ? '9947' : sessionStorage.getItem('channel');

    const Rhref = window.location.host;
    
    if (Rhref.indexOf('rlchltd') > -1) {
      var url = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'

    } else {
      var url = origin + '/subject/download?channel=' + channel

    }
    if (Rhref.indexOf('hspluspro') > -1 || Rhref.indexOf('hsrlcool') > -1 || Rhref.indexOf('sem.hslefu') > -1||Rhref.indexOf('sem.hshjlexiang') > -1) {
      this.hideDate = true

    } else {
      this.hideDate = false

    }

      const icon = require('../../static/index/hongshi.jpg')

    generateQRCode(url, this.$refs.qrcodeCanvas, icon)
    //获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {   
    // 跳转链接
    jumpClick(attr) {
      window.open(attr);
    },
    //获取Android下载链接
    async getAndroidUrl(code) {
      const Rhref = window.location.host;

      if (Rhref.indexOf('rlchltd') > -1) {
        this.androidUrl = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'
      } else {
        const res = await getChannelInfo(code)
        const { downloadUrl } = res;
        this.APKurl = downloadUrl || '';
        const { origin } = window.location;
        const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
        if (absoluteURLRegex.test(downloadUrl)) {
          this.androidUrl = downloadUrl
        } else {
          this.androidUrl = origin + '/' + downloadUrl
        }
      }

    },
      //获取ios下载链接
      async getIosUrl() {
        const res = await getConfigurationValue({ key: 'H5URLBeforeA'})
        if (res) {
          this.iosUrl = await getActiveDomain(res)
        }
      },
      iosDownload(){
        // window.location.href = 'https://apps.apple.com/cn/app/id1598072476';
        window.location.href = this.iosUrl;
      },
      androidDownload(){
        window.location.href = this.androidUrl;
      }  , 
    // 获取swiper接口
      initSwiper(){
        
        const params = {
          languageIdentification: '1',
          type: '35',
          brandId: '1',
          region: '1',
        }
        queryBrandImgList(params).then((res) => {
          if (res && res.length > 0) {
            this.swiperData = res;

          } else {
            this.imgData = res[0];


          }
          if (this.swiperData.length < 2) {
            this.swiperOption.loop = false;
          }
        }).catch(err => {
          console.log(err);
        })
      },
    // 选择时间
    selectTime(e){
  
      this.selectIndex1=e
      eventBusMitter.emit('eventBus1', {key:e})
      if(this.changeType==1){
      this.initCharts()
          
      }else{
        this.initCharts1()
      }
    },
   
    // 点击跳转到指定位置
    scrollToTarget() {
      const targetElements = this.$refs.targetElement;
      const targetPosition = targetElements.offsetTop ;
      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    },
    // 切换为K线图
    changeTypes(){
      this.changeType=2
      this.initCharts1()
    },
    changeTypes1(){
      this.changeType=1
      this.initCharts()
    },
   
    // 切换图表数据伦敦银
    btnChange(){
      this.selectIndex=1
      eventBusMitter.emit('eventBus', {key:'GOLD'})
      this.initCharts()
  
    },
    // 伦敦金
    btnChange1(){
      this.selectIndex=2
      eventBusMitter.emit('eventBus', {key:'SILVER'})
      this.initCharts()
    },
  
    // 获取echart数据
    initCharts(){
      
      var chartDom = document.getElementById("echartsBox_one");
      var myChart = echarts.init(chartDom);
      let dataArr=this.dataArr
      let date = [];
      let data = [];
      let data1=[];
      dataArr.map(item=>{
        if(this.selectIndex1==1||this.selectIndex1==2){
              data.push(item[1])
              date.push(item[0])
              data1.push({name:item[1],value:this.timestampToTime(item[6]*1000)})
              
          }else{
               data.push(item[1])
               date.push(item[0])
          }
      })
 
      let option = {
         tooltip: {
          trigger: 'axis',
          formatter: params => {
            
            const data = params[0];
     
            let title=''
            
        
            if(data1.length>0){
              data1.forEach(item=>{
              if(item.name==params[0].data){
                title=' '+' '+item.value
              }
            })
            }else if(data1.length==0){
              title=''
            }
            
          return `${data.name}${title} <br>${data.marker} ${data.data}  `;
          }
        },
        title: {
          left: 'center',
          text: ''
        },
        toolbox: {
          feature: {
           
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: date,

        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          position:'right',
    scale: true,

        },
        grid:{
          right:50,
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 100
          }
        ],
        series: [
          {
            name: 'Fake Data',
            type: 'line',
            symbol: 'none',
            sampling: 'lttb',
            itemStyle: {
              color: 'rgb(255, 70, 131)'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgb(255, 158, 68)'
                },
                {
                  offset: 1,
                  color: 'rgb(255, 70, 131)'
                }
              ])
            },
            data: data
          }
        ]
      };
     
      myChart.setOption(option);
    },
    //k线图
     initCharts1(){
      var chartDom = document.getElementById("echartsBox_one");
      var myChart = echarts.init(chartDom);
      let dataArr=this.dataArr
      let date = [];
      let data = [];
      let data1=[]
      if(dataArr&&dataArr.length>0){
         dataArr.map(item=>{
        
        
        if(this.selectIndex1==1||this.selectIndex1==2){
             data1.push([item[1],item[2],item[3],item[4],this.timestampToTime(item[6]*1000)])
             data.push([item[1],item[2],item[3],item[4]])
        date.push(item[0]) 
              
          }else{
              data.push([item[1],item[2],item[3],item[4]])
              date.push(item[0])
          }
        
      })
      }
      let xAxisDataSet = new Set();
      let xAxisDateIndex = 0;
      let option = {
 
      tooltip: {
       trigger: 'axis',
       formatter: params => {
      
      const data = params[0];
   
            let title='开：'+data.data[1]
            let title1='高：'+data.data[3]
            let title2='低：'+data.data[4]
            let title3='收：'+data.data[2]
            let titles=''
        
            if(data1.length>0){
              data1.forEach(item=>{
              if(item[0]==params[0].data[1]){
                titles=' '+' '+item[4]
              }
            })
            }else if(data1.length==0){
              titles=''
            }
            
          return `${data.name}${titles} <br>${data.marker}  \u00A0${title}<br>${data.marker}  \u00A0${title1}<br>${data.marker} \u00A0${title2}<br>${data.marker}  \u00A0${title3} `;
    }
   
      },
  xAxis: {
    type: 'category',
    data: date,
    axisLabel: {
        formatter: (value, index) => {
          if(this.selectIndex1==1||this.selectIndex1==2){
            if (index < xAxisDateIndex) {
            xAxisDataSet.clear();
          }
          xAxisDateIndex = index;
          const date = value;
          const d = xAxisDataSet.has(date);
          if (!d) {
            xAxisDataSet.add(date);
            return date;
          }
          return '';
          }
          else{
            return value
          }
        }
      },
    axisLine: { lineStyle: { color: '#8392A5' } }
      },
       yAxis: {
    scale: true,
    axisLine: { lineStyle: { color: '#8392A5' } },
    splitLine: { show: false },
    position: 'right',
       },
       grid: {
      bottom: 80
      },
  dataZoom: [
    {
      type: 'inside',
      xAxisIndex: [0, 1],
      start: 190,
      end: 200
    },
    {
      show: true,
      xAxisIndex: [0, 1],
      type: 'slider',
      bottom: 190,
      start: 200,
      end: 20
    }
  ],
  series: [
    {
      type: 'candlestick',
      name: this.selectIndex==1?'伦敦金':'伦敦银',
      data: data,
      itemStyle: {
        color: '#FD1050',
        color0: '#0CF49B',
        borderColor: '#FD1050',
        borderColor0: '#0CF49B'
      }
    },
   
  ]
};
     
      myChart.setOption(option);
  
    },
   
    closer() {
      this.closerControl = !this.closerControl;
    },
    handleScroll() {
      
    },
    timestampToTime(timestamp) {
      let date = new Date(parseInt(timestamp));
      let Year = date.getFullYear();
      let Moth =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let Day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let Hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let Minute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let Sechond =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Hour + ":" + '00';
    },
   timestampToTime (data) {
   var time;
   var hours = parseInt((data % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
   var minutes = parseInt((data % (1000 * 60 * 60)) / (1000 * 60));
   var seconds = (data % (1000 * 60)) / 1000;
   time = (hours < 10 ? ('0' + hours) : hours) + ':' + (minutes < 10 ? ('0' + minutes) : minutes) + ':' + (seconds < 10 ? ('0' + seconds) : seconds);
   return hours+':'+'00';
    }

    
  
  },
   computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.scrollTop;
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    dataArr(){
      return this.$parent.dataArr
    },
    golds(){
      return this.$parent.goldData
    },
    high(){
      return this.$parent.goldData1
    },

    priceRange(){
    let value=(this.golds-this.high).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.high? ((Math.abs(value) * 100) / this.high).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     hk50(){
      return this.$parent.hk50
    },
    hk501(){
      return this.$parent.hk501
    },

    priceRange4(){
    let value=(this.hk50-this.hk501).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.hk501? ((Math.abs(value) * 100) / this.hk501).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     nas(){
      return this.$parent.nas
    },
    nas1(){
      return this.$parent.nas1
    },

    priceRange3(){
    let value=(this.nas-this.nas1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.nas1? ((Math.abs(value) * 100) / this.nas1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
    sliver(){
      return this.$parent.sliver
    },
    sliver1(){
      return this.$parent.sliver1
    },

    priceRange1(){
    let value=(this.sliver-this.sliver1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.sliver1? ((Math.abs(value) * 100) / this.sliver1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     usd(){
      return this.$parent.usd
    },
    usd1(){
      return this.$parent.usd1
    },

    priceRange2(){
    let value=(this.usd-this.usd1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.usd1? ((Math.abs(value) * 100) / this.usd1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
   
   
  },
   watch: {
    screenWidth(n) {
      if (n > 500) {
        this.$router.push({
          name: "Index",
        });
      }
    },

     // 选择数据图表数据
    dataArr(newVal){
        if(newVal&&this.changeType==1){
           this.initCharts()
        }else{
          this.initCharts1()
        }
    },
   
   
    
  },
};
</script>

<style lang="less" scoped>
.indexBox {
  width: 100%;
  box-sizing: border-box;
  .dark {
    .background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5); /* 背景颜色设置为半透明黑色 */
    }
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;

    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 343px;
      opacity: 1;
      position: relative;
    }
    .closer3 {
      width: 30px;
      position: relative;
      top: -260px;
      right: 0%;
      cursor: pointer;
    }
  }
  .bigImg {
    width: 100%;
    height: 750px;
      width: 7.5rem;
      // height: 9.2rem;
    // background: url("../../static/wap/index/topbg.png") no-repeat;

      box-sizing: border-box;
      // overflow: hidden;
      background-size: cover;

    // display: flex;
    // flex-direction: column;
    // align-items: center;
    position: relative;
    /deep/ .swiper-container {
     
      .swiper-slide {

        img {
          width: 100%;
          height:auto;//
          height: 750px;
          // object-fit: cover;
        }
      }
      .swiper-pagination {
        .swiper-pagination-bullet-active {
          background-color: #e1352a;
        }
      }
    }
    .title {
      font-size: 58px;
      line-height: 77px;
      color: #fff;
      font-weight: 700;
    }
    .titles {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      margin: 6px 0 24px 0;
    }
    .topimg {
      width: 110px;
      height: 30px;
      margin: 28px 0 6px 0;
    }
    .download {
      width: 180px;
      height: 34px;
    }
    .flex {
      display: flex;
      align-items: center;
    }
    .flex1 {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    //市场
    .topbox {
      width: 86%;
      height: 40px;
      overflow: scroll;
      display: flex;
      position: absolute;
      left: 1rem;
      bottom: -4%;
      z-index: 10;
      white-space: nowrap;
      .boxs {
        width: 164px;
        height: 40px;
        background: #fff;
        color: #fff;
        margin-right: 10px;
        padding: 10px 12px;
        box-sizing: border-box;
        .left {
          background: #1552ac;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          font-size: 14px;
          line-height: 19px;
          margin-right: 7px
        }
        .right {
          font-size: 12px;
          line-height: 17px;
          .txt {
            font-size: 10px;
            color: #93939f;
            width: 36px;
          }
          .txts{
            color: #0F0F11;
            font-size: 12px;
            line-height: 17px;
            font-weight: 600;

          }
          .cont {
            display: flex;
            // flex-direction: column;
          }
        }
      }
     
      
    }
  }
 
  .flexs {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: nowrap;
  }
  .part1 {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    z-index: 9;
    // padding: 0 1rem;
    box-sizing: border-box;
    .part1-top {
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px;
      margin: 0 auto;
      .icon1 {
        display: flex;
        align-items: center;
    
        padding: 10px;
        // width: 42%;
        height: 82px;
        box-sizing: border-box;
        white-space: nowrap;
        img {
          margin-left: 14px;
          width: 36px;
          height: 30px;
        }
        .indexTitle1{
          margin: 0;
        }
      }
      .icon-txt {
        color: #fa2314;
        font-size: 10px;
        line-height: 14px;
      }
      .icon-txt1 {
        color: #0f0f11;
        font-size: 18px;
        line-height: 21px;
        width: 91px;
      }
      .icon-txt2 {
        color: #11c771;
        font-size: 10px;
        line-height: 14px;
      }
    }
    .select{
          background: rgba(15, 15, 17, 0.1);
      }
    .part-tit {
      margin: 6px 0 28px 0;
    }
    .echartsBoxItem{
      height: 248px;
       width: 360px;
 
          margin: 0 auto;
   
    }

    // echarts图表
     .part1-select{
      width: 80%;
      padding: 0 1rem;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 15%;
      cursor: pointer;
      .part1-box{
        width: 68px;
        height: 32px;
        border-radius: 6px ;
        border: 1px solid #C9C9CF;
        box-sizing: border-box;
        margin-left: 20px;
        img{
          width: 24px;
          height: 24px;
        }
        .changes{
          background: rgba(201, 201, 207, 0.4);

        }
        .mgs{
          margin-right: 10px;
        }

        margin-right: 16px;

      }
      .part1-boxs{
        width: 36px;
        height: 36px;
        border-radius: 6px ;
     
        border: 1px solid #C9C9CF;
        img{
          width: 18px;
          height: 18px;
        }
      }
    }
    .part1-felx{
      display: flex;
      align-items: center
    }
    .part1-felx1{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .timelist{
      color: #C9C9CF;
      font-size: 10px;
      line-height: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 6px;
      div{
        width: 42px;
        height: 32px;
        border-radius: 6px;
        box-sizing: border-box;
      }
      .selcts{
        color: #0F0F11;
        background: rgba(201, 201, 207, 0.4);
      }
    }
  }
  .part2 {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0 1rem;
    box-sizing: border-box;
    .indexTitle1 {
      // width: 343px;
      text-align: left;
    }
    .phone {
      width: 241px;
      height: 385px;
      // margin: 0 67px;
    }
    .part2-bott {
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      flex-wrap: wrap;
      margin: 36px 0;
      div {
        display: flex;
        align-items: center;
        margin-bottom: 31px;
        .icons {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        span {
          font-size: 12px;
          line-height: 20px;
          color: #0f0f11;
        }
      }
    }
    .part2-down {
      display: flex;
      align-items: center;
      .code {
        
        margin-right: 16px;
        .canvasCode{
           width: 156px;
        height: 156px;
        }
      }
      .download {
        width: 171px;
        height: 50px;
        margin-bottom: 16px;
      }
      span {
        color: #93939f;
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
  .part3 {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-top: 48px;
    padding: 0 0.2rem;
    box-sizing: border-box;
    .indexTitle {
      margin: 0;
    }
    .part3-left {
      width: 142px;
      height: 130px;
      padding: 10px 12px 20px 10px;
      box-sizing: border-box;
      background: linear-gradient(105.21deg, #fa2314 0%, #db2c23 100%);
      color: #fff;
      .tops {
        font-size: 14px;
        line-height: 20px;
      }
      .line {
        width: 22px;
        height: 2px;
        margin: 4px 0 6px 0;
        background: #fff;
      }
      .conts {
        font-size: 10px;
        line-height: 16px;
        text-align: left;
      }
    }
    .part3-right {
      img{
 width: 211px;
      height: 148px;
      }
     
    }
  }
  .part4 {
    width: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    margin-top: 48px;
    // padding: 0 0.5rem;
    // box-sizing: border-box;
    
    .part4-img{
      width: 100%;
      height: auto;
    }
    .indexTitle {
      margin: 0;
    }
    .tits{
        color: #93939F;
        text-align: center;

    }
  }
  .indexTitle {
    font-size: 36px;
    line-height: 50px;
    color: #0f0f11;
    margin-top: 48px;
    span {
      color: #fa2314;
    }
    text-align: center;
  }
  .indexTitle1 {
    font-size: 14px;
    line-height: 20px;
    color: #0f0f11;
    margin: 6px 0 28px 0;
    span{
        font-weight: 700;
    }
  }
  .part-flex {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .fourBox {
    width: 7.5rem;
    height: 11.1rem;
    //   background: url('../../static/index/wap/secondBanner.png') no-repeat;
    background-size: cover;
    box-sizing: border-box;
    padding: 0.6rem 0.4rem;
    .fbTop {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.3rem;
      div {
        width: 3.2rem;
        height: 4.8rem;
        box-sizing: border-box;
        padding: 0 0.48rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        img {
          width: 0.5rem;
        }
        span:nth-child(2) {
          font-size: 0.28rem;
          color: #121212;
          margin: 0.21rem 0 0.13rem;
        }
        span:nth-child(3) {
          font-size: 0.2rem;
          color: #6d6d6d;
        }
        p {
          font-size: 0.18rem;
          line-height: 0.3rem;
          color: #939393;
          text-align: justify;
          margin-top: 0.4rem;
        }
      }
      div:nth-child(1) {
        //   background: url('../../static/index/wap/zBanner1.png') no-repeat;
        background-size: cover;
      }
      div:nth-child(2) {
        //   background: url('../../static/index/wap/zBanner2.png') no-repeat;
        background-size: cover;
        box-sizing: border-box;
        padding-top: 0.26rem;
      }
    }
    .fbBottom {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      div {
        width: 3.2rem;
        height: 4.8rem;
        box-sizing: border-box;
        padding: 0 0.48rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        img {
          width: 0.5rem;
        }
        span:nth-child(2) {
          font-size: 0.28rem;
          color: #121212;
          margin: 0.21rem 0 0.13rem;
        }
        span:nth-child(3) {
          font-size: 0.2rem;
          color: #6d6d6d;
        }
        p {
          font-size: 0.18rem;
          line-height: 0.3rem;
          color: #939393;
          text-align: justify;
          margin-top: 0.4rem;
        }
      }
      div:nth-child(1) {
        //   background: url('../../static/index/wap/zBanner3.png') no-repeat;
        background-size: cover;
      }
      div:nth-child(2) {
        //   background: url('../../static/index/wap/zBanner4.png') no-repeat;
        background-size: cover;
      }
    }
  }
  .serveBox {
    width: 7.5rem;
    .sbControl {
      width: 7.5rem;
      // margin: 0 auto;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      border-bottom: 1px solid #e2e2e2;
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;
      .ulBottom {
        border-bottom: 0.04rem solid #d52226;
      }
      ul {
        width: 25%;
        display: inline-block;
        height: 1.5rem;
        cursor: pointer;
        li {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          font-size: 0.15rem;
          color: #6d6d6d;
          .svgColor {
            color: #d52226;
          }
          span {
            font-size: 0.28rem;
            color: #121212;
          }
          i {
            font-size: 0.26rem;
          }
        }
        li:nth-child(2) {
          margin: 0.1rem 0 0.3rem;
        }
      }
      ul:last-child {
        margin-left: 0.3rem;
      }
      ul:nth-child(4) {
        margin-left: 0.3rem;
      }
    }
    // 隐藏滚动条
    .sbControl::-webkit-scrollbar {
      display: none;
    }
    .sbShow {
      width: 100%;
      .showChild {
        width: 100%;
        height: 4.8rem;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        div {
          width: 100%;
          font-size: 0.22rem;
          height: 4rem;
          display: flex;
          justify-content: space-around;
          align-items: flex-start;
          line-height: 0.5rem;
          color: #121212;
          background-size: cover;
          box-sizing: border-box;
          padding-top: 0.7rem;
        }
        .showChildDiv1 {
          // background: url('../../static/index/wap/textBanner1.png') no-repeat;
          background-size: cover;
        }
        .showChildDiv2 {
          // background: url('../../static/index/wap/textBanner2.png') no-repeat;
          background-size: cover;
        }
        .showChildDiv3 {
          // background: url('../../static/index/wap/textBanner3.png') no-repeat;
          background-size: cover;
        }
        .showChildDiv4 {
          // background: url('../../static/index/wap/textBanner4.png') no-repeat;
          background-size: cover;
        }
        .showChildDiv5 {
          // background: url('../../static/index/wap/textBanner5.png') no-repeat;
          background-size: cover;
        }
      }
    }
  }
 
}
/deep/ #box {
  margin-top: 100px;
}

// 设置swiper分页器的样式
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 55px;
}
/deep/ .swiperOne {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    width: 4px;
    height: 4px;
    background-color: #999999;
    border-radius: 50%;
  }
  li {
    width: 20px;
    height: 20px;
    border: 2px solid #d52226;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      width: 4px;
      height: 4px;
      background-color: #d52226;
      border-radius: 50%;
    }
  }
  .swiperOneSpan {
    margin: 0 30px;
  }
}
/deep/ .swiperTwo {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    width: 4px;
    height: 4px;
    background-color: #999999;
    border-radius: 50%;
  }
  li {
    width: 20px;
    height: 20px;
    border: 2px solid #d52226;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 30px;
    span {
      width: 4px;
      height: 4px;
      background-color: #d52226;
      border-radius: 50%;
    }
  }
}
/deep/ .swiperThree {
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    width: 4px;
    height: 4px;
    background-color: #999999;
    border-radius: 50%;
  }
  li {
    width: 20px;
    height: 20px;
    border: 2px solid #d52226;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      width: 4px;
      height: 4px;
      background-color: #d52226;
      border-radius: 50%;
    }
  }
  .swiperThreeSpan {
    margin: 0 30px;
  }
}
</style>